import React from "react";
import RoomBlock from "./RoomBlock";
import { Grid, Segment } from "semantic-ui-react";
import _ from "lodash";
import moment from "moment";
import { OccupancyModal } from "./OccupancyModal";
import { isToday } from "../../utils/helpers/date";
import { LOADING } from "../../utils/helpers/phases";

const setColor = (status, date) => {
  if (!isToday(date)) return undefined;
  switch (status) {
    case "cleaning":
      return "yellow";
    case "cleaned":
      return "green";
    case "dirty":
      return "red";
    default:
      return undefined;
  }
};
const getCleaningList = (cleaning, roomId, date, users) => {
  const selectedDate = moment.utc(date);

  const roomCleaning = cleaning
    .filter(
      c =>
        c.rooms.find(r => r.roomId === roomId) &&
        moment.utc(c.from) <= selectedDate &&
        moment.utc(c.to) >= selectedDate
    )
    .map(cleaning => ({
      ...cleaning,
      user: users.find(u => u.userId === cleaning.userId) || {}
    }));

  return roomCleaning;
};
const getArrival = (roomsInfo, roomId) => {
  const roomInfo = roomsInfo.find(r => r.roomId === roomId) || {};
  return roomInfo.arrival || {};
};
const getDeparture = (roomsInfo, roomId) => {
  const roomInfo = roomsInfo.find(r => r.roomId === roomId) || {};
  return roomInfo.departure || {};
};
const getStay = (roomsInfo, roomId) => {
  const roomInfo = roomsInfo.find(r => r.roomId === roomId) || {};
  return roomInfo.stay || {};
};
const getNote = (roomsInfo, roomId) => {
  const roomInfo = roomsInfo.find(r => r.roomId === roomId);
  return roomInfo ? roomInfo.note : "";
};

const HotelStructure = props => {
  const groupedByFloorRooms = _.groupBy(props.rooms, room => room.floor);
  const panels = Object.keys(groupedByFloorRooms).map((floor, key) => {
    const roomBlocks = (
      <Grid key={key} stackable>
        {groupedByFloorRooms[floor].map((room, i) => {
          return (
            <Grid.Column
              mobile={16}
              tablet={7}
              computer={4}
              widescreen={3}
              key={i}>
              <RoomBlock
                color={setColor(room.status, props.date)}
                key={i}
                t={props.t}
                name={room.name}
                loading={props.occupancyPhase === LOADING}
                note={getNote(props.roomsInfo, room.roomId)}
                cleaningList={getCleaningList(
                  props.cleaning,
                  room.roomId,
                  props.date.toDate(),
                  props.users
                )}
                arrival={getArrival(props.roomsInfo, room.roomId)}
                departure={getDeparture(props.roomsInfo, room.roomId)}
                stay={getStay(props.roomsInfo, room.roomId)}
                handleClick={() => {
                  if (props.toggleModal && props.isAdmin) {
                    const occupancy = props.roomsInfo.find(
                      r => r.roomId === room.roomId
                    ) || {
                      roomId: room.roomId
                    };
                    props.toggleModal(occupancy);
                  }
                }}
              />
            </Grid.Column>
          );
        })}
      </Grid>
    );
    return (
      <Segment.Group key={key}>
        <Segment secondary compact style={{ fontWeight: "bold" }}>
          {`${floor} ${props.t("hotelStructure:floor")}`}
        </Segment>
        <Segment compact>{roomBlocks}</Segment>
      </Segment.Group>
    );
  });
  return (
    <React.Fragment>
      <OccupancyModal {...props} future={!isToday(props.date)} />
      {panels}
    </React.Fragment>
  );
};

export default HotelStructure;



// WEBPACK FOOTER //
// ./src/rooms/HotelStructure/HotelStructure.js